// Services accordion
const accordion = require(MODULES_PATH + '/accordion');

const gifImages = document.querySelectorAll('.animated-gif-item');

function restartGif(imageContainer) {
    const gifImage = imageContainer.querySelector('img');
    if (!gifImage) return;
    const gifSrc = gifImage.src.split('?')[0];
    gifImage.src = '';
    gifImage.src = gifSrc + '?t=' + new Date().getTime();
}

new accordion({
    selector: '.accordion',
    duration: 200,
    openOnInit: [0],
    collapse: false,
    beforeOpen: (currentElement) => {
        const accordionItems = document.querySelectorAll('.accordion .accordion-item');
        const currentIndex = Array.from(accordionItems).indexOf(currentElement);

        gifImages.forEach((img) => img.classList.remove('active'));

        const targetImage = document.querySelector(`.animated-gif-item[data-image="${currentIndex}"]`);
        if (targetImage) {
            targetImage.classList.add('active');
            restartGif(targetImage);
        }
    },
});

setTimeout(() => {
    const firstImage = document.querySelector('.animated-gif-item[data-image="0"]');
    if (firstImage) {
        firstImage.classList.add('active');
        restartGif(firstImage);
    }
}, 100);
